import React, { useState, useEffect } from 'react';
import apiClient, { API_BASE_URL } from '../utils/apiClient';
import './Support.css';
import Navbar from '../components/Navbar';
import qrCodeImage from '../assets/pay.png';
import wechatQRCode from '../assets/rgm-wechat-qr.png';
import wechatLogo from '../assets/wechat-logo.png';
import heyboxLogo from '../assets/heybox-logo.png';
import oldgameButton from '../assets/friend-oldgame-zh.gif';
import pkugarcLogo from '../assets/friend-pkugarc.svg';
import fengchengLogo from '../assets/friend-fengcheng.png';
import jlgamesLogo from '../assets/friend-jlgames.png';
import { Link } from 'react-router-dom';

const About = () => {
  const [showQRCode, setShowQRCode] = useState(false);
  const [credits, setCredits] = useState([]);
  const [daysRunning, setDaysRunning] = useState(0);
  const [contact, setContact] = useState({ wechat: '', email: '' });

  const toggleQRCode = () => {
    setShowQRCode(!showQRCode);
  };

  // Calculate days running from 2023.5.6 to today
  useEffect(() => {
    const startDate = new Date(2023, 4, 6); // May 6, 2023 (months are 0-indexed)
    const today = new Date();
    const days = Math.floor((today - startDate) / (1000 * 60 * 60 * 24));
    setDaysRunning(days);
  }, []);

  useEffect(() => {
    apiClient.get('/site-contact')
      .then((response) => setContact(response.data))
      .catch((error) => console.error('Error fetching site contact information:', error));
  }, []);

  // Fetch credits from the database
  useEffect(() => {
    const fetchCredits = async () => {
      try {
        const response = await apiClient.get('/credits');
        setCredits(response.data);
      } catch (error) {
        console.error('Error fetching credits:', error);
      }
    };
    fetchCredits();
  }, []);
  
  return (
    <div className="support-wrapper">
      <Navbar />
      <div className="support-container">
        <div className="support-header">
          <h1 className="weight-bold">关于我们</h1>
        </div>

        <div className="support-content">
          <div className="support-section">
            <h2 className="weight-bold">关于怀旧游戏博物馆</h2>
            <p>
            怀旧游戏博物馆(Retro Game Museum)是一个致力于老游戏保护和展示的非盈利项目，于2023年正式发起。我们致力于将不同地域的电子与传统游戏经典档案，让他们可以在浏览器中直接体验。在电子游戏承载偏见的当下，我们希望这成为玩家们回返忘不掉的游戏时光的一个地方，也希望当玩家们体验到不同大陆，不同年代的游戏时也能收获同样的快乐和感动。
            </p>
            <div className="old-website-section">
              <p>想看看我们是怎么开始的？</p>
              <a href="https://old.rgm.games" className="support-link old-website-link" target="_blank" rel="noopener noreferrer">
                访问旧版网站
              </a>
            </div>
          </div>

          <div className="support-section">
            <h2 className="weight-bold">支持方式</h2>
            
            <div className="supporters-subsection">
              <p>怀旧游戏博物馆 <span className="running-days-number">{daysRunning}</span> 天的无广告运营因以下支持者可能：</p>
              <div className="supporters-list">
                <p>李白</p>
                <p>Skyy</p>
                <p>日出东逝.月落西希。杨雄焘</p>
                <p>AsakaYunyu</p>
                <p>爱发电用户_75049</p>
                <p>大菲</p>
                <p>Tentacle</p>
                <p>张小潇</p>
                <p>爱发电用户_e99b2</p>
                <p>爱发电用户_d348d</p>
                <p className="special-sponsor">
                  <a href="https://www.compumuseum.com/" target="_blank" rel="noopener noreferrer">
                    网页里的电脑博物馆
                  </a>
                </p>
                <p>糖</p>
                <p>苏提</p>
                <p>KingDavid456</p>
                <p>小雅</p>
                <p>吉川优子</p>
                <p>慕龙如雪</p>
                <p>freeman-C3</p>
                <p>爱发电用户_th6D</p>
                <p>StolZ</p>
                <p>羽宫七音</p>
                <p>JÄGER</p>
                <p>乐yy</p>
                <p>大魏拳王崔季舒</p>
                <p>William</p>
                <p>爱狸使命</p>
                <p>没了你要</p>
                <p>AAA专业回收草莓籽</p>
                <p>Reflection</p>
                <p>清心</p>
                <p>星尘_</p>
                <p>德行行清没想到吧名字有四种念法你猜到了吗？</p>
              </div>
            </div>

            <div className="support-methods">
              <div className="support-method">
                <h3>爱发电</h3>
                <p>通过爱发电平台进行小额赞助</p>
                <a href="https://ifdian.net/a/rgmuseum" className="support-link" target="_blank" rel="noopener noreferrer">
                  前往爱发电
                </a>
              </div>
              
              <div className="support-method">
                <h3>微信赞赏</h3>
                <p>使用微信扫码赞赏</p>
                <button className="support-link" onClick={toggleQRCode}>
                  显示赞赏码
                </button>
              </div>
            </div>
          </div>

          <section className="support-section social-section" aria-labelledby="social-section-title">
            <div className="social-section-heading">
              <h2 id="social-section-title" className="weight-bold">馆刊与动态</h2>
              <p className="social-section-intro">
                从游戏史考据到馆藏故事 - 关注我们的内容阵地，也见证博物馆的每一步更新。
              </p>
            </div>

            <div className="social-platforms">
              <article className="social-card social-card-wechat">
                <div className="social-card-copy">
                  <div className="wechat-logo-wrap">
                    <img src={wechatLogo} alt="微信" />
                  </div>
                  <h3>关注 RGM 微信公众号</h3>
                  <p>长篇馆刊、游戏文化专题与项目一手动态。</p>
                  <div className="social-card-meta">
                    <span>内容负责人</span>
                    <strong>业羊</strong>
                  </div>
                </div>
                <div className="wechat-qr-wrap">
                  <img src={wechatQRCode} alt="Retro Game Museum 微信公众号二维码" />
                  <span>微信扫码关注</span>
                </div>
              </article>

              <article className="social-card social-card-heybox">
                <div className="social-card-copy">
                  <div className="heybox-logo-wrap">
                    <img src={heyboxLogo} alt="小黑盒" />
                  </div>
                  <h3>找到我们的社区专栏</h3>
                  <p>短篇观察、编辑推荐，以及更及时的馆藏与网站进展。</p>
                  <div className="heybox-search" aria-label="请在小黑盒中搜索怀旧游戏博物馆">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="m21 21-4.35-4.35m2.35-5.65a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" />
                    </svg>
                    <span>怀旧游戏博物馆</span>
                    <b>搜索</b>
                  </div>
                  <div className="social-card-meta">
                    <span>内容负责人</span>
                    <strong>云雲</strong>
                  </div>
                </div>
              </article>
            </div>
          </section>

          <div className="support-section">
            <h2 className="weight-bold">加入我们</h2>
            <p>怀旧游戏博物馆是游戏爱好者社区下的产物，如果你对我们的志业有兴趣，欢迎加入我们。</p>
            <Link to="/enlist" className="support-link">
              申请成为档案员
            </Link>
          </div>

          <div className="support-section">
            <h2 className="weight-bold">成员</h2>
            <div className="team-members-list">
              <div className="member-item">
                <div className="member-header">
                  <div className="member-identity">
                    <h3 className="member-name">俞果</h3>
                    <a
                      className="member-website"
                      href="https://guoyu.rgm.games"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="访问俞果的个人网站（在新窗口打开）"
                    >
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="12" cy="12" r="9" />
                        <path d="M3 12h18M12 3c2.4 2.5 3.6 5.5 3.6 9s-1.2 6.5-3.6 9c-2.4-2.5-3.6-5.5-3.6-9S9.6 5.5 12 3Z" />
                      </svg>
                      <span>个人网站</span>
                      <svg className="member-website-arrow" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M5 11 11 5M6 5h5v5" />
                      </svg>
                    </a>
                  </div>
                  <span className="member-game">喜欢的游戏: 浴火银河2</span>
                </div>
                <p className="member-description">玩着雅达利长大并追它追到了美国上学，梦想是在中国开一家有街机的披萨店。</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">耿游子民</h3>
                  <span className="member-game">喜欢的游戏: 最终幻想·核心危机</span>
                </div>
                <p className="member-description">任索steam三修，偏好JRPG&p5天下第一</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">YJCOP</h3>
                  <span className="member-game">喜欢的游戏: GTA圣安地列斯</span>
                </div>
                <p className="member-description">一个玩家</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">Quhorlop</h3>
                  <span className="member-game">喜欢的游戏: 极乐迪斯科</span>
                </div>
                <p className="member-description">公共世界有其可编逻辑，但总有一两句未加载完。工作区在表层之下，感兴趣的是语调，而非命题。</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">天道</h3>
                  <span className="member-game">喜欢的游戏: 卡片召唤师</span>
                </div>
                <p className="member-description">游戏陪我长大的80后</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">寒刃</h3>
                  <span className="member-game">喜欢的游戏: Skate Story</span>
                </div>
                <p className="member-description">滑板公主拯救滑板故事</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">业羊</h3>
                  <span className="member-game">喜欢的游戏: Epic Battle Fantasy 5</span>
                </div>
                <p className="member-description">来自江苏</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">卜卜</h3>
                  <span className="member-game">喜欢的游戏: 功夫小子</span>
                </div>
                <p className="member-description">猴批，晕3D，爱动作游戏但手残，想玩回合制但没耐心，喜欢卡牌但不想动脑</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">NolanLiee</h3>
                  <span className="member-game">喜欢的游戏: 怪物猎人：世界</span>
                </div>
                <p className="member-description">从媒体人转职为程序员的冒险家，探索AI 时代的交互媒介和内容。游戏文化爱好者。</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">云雲</h3>
                  <span className="member-game">喜欢的游戏: 小花仙</span>
                </div>
                <p className="member-description">还在为小花仙拉磨是因为我有品吗，不，是因为我白月光在它手里（咬牙切齿 jpg.）</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">404</h3>
                  <span className="member-game">喜欢的游戏: 废墟图书馆</span>
                </div>
                <p className="member-description">FACE THE FEAR, BUILD THE FUTURE</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">米乐</h3>
                  <span className="member-game">喜欢的游戏: 奥日与黑暗森林</span>
                </div>
                <p className="member-description">游戏历史爱好者，沉迷于整理游戏的历史而乐不思反。</p>
              </div>

              <div className="member-item">
                <div className="member-header">
                  <h3 className="member-name">李志鹏</h3>
                  <span className="member-game">喜欢的游戏: Crimsonland</span>
                </div>
                <p className="member-description">游戏研究者，大抵是老了，从3A玩回远古休闲小体量PC游戏了</p>
              </div>
            </div>
          </div>

          <div className="support-section">
            <h2 className="weight-bold">联系我们</h2>
            <div className="contact-info">
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M996.427776 623.853568c0-139.354112-138.063872-251.815936-291.87072-251.815936-162.281472 0-290.656256 112.461824-290.656256 251.815936 0 139.352064 128.374784 251.807744 290.656256 251.807744 35.119104 0 69.031936-11.001856 104.148992-18.331648l92.043264 52.559872-24.2176-88.014848c67.821568-50.122752 119.896064-119.791616 119.896064-198.02112z m-386.338816-45.24032c-16.95744 0-33.906688-15.890432-33.906688-31.77472 0-19.562496 16.95744-35.446784 33.906688-35.446784 25.438208 0 43.599872 15.890432 43.599872 35.446784 0.002048 15.884288-18.161664 31.77472-43.599872 31.77472z m190.144512 0c-18.167808 0-33.910784-15.890432-33.910784-31.77472 0-19.562496 15.745024-35.446784 33.910784-35.446784 24.219648 0 42.387456 15.890432 42.387456 35.446784 0 15.884288-18.169856 31.77472-42.387456 31.77472z" />
                  <path d="M683.97056 352.48128c9.68704 0 20.588544 1.216512 32.700416 3.672064-29.063168-141.809664-178.03264-242.044928-345.155584-242.044928-188.925952 0-343.943168 127.127552-343.943168 293.373952 0 94.130176 50.868224 171.145216 136.855552 232.25344l-35.131392 105.132032 122.318848-62.347264c42.385408 12.232704 75.087872 19.562496 119.90016 19.562496 9.68704 0 20.594688 0 30.27968-1.216512-6.053888-24.45312-9.684992-47.681536-9.684992-73.34912 0-150.355968 127.156224-275.03616 291.86048-275.03616z m-185.2928-91.686912c26.64448 0 43.599872 15.890432 43.599872 42.78272 0 25.675776-16.955392 42.784768-43.599872 42.784768-25.432064 0-49.657856-17.1008-49.657856-42.784768 0-26.894336 24.225792-42.78272 49.657856-42.78272z m-239.794176 85.573632c-25.432064 0-52.076544-17.115136-52.076544-42.79296 0-26.894336 26.64448-42.78272 52.076544-42.78272 24.223744 0 43.599872 15.890432 43.599872 42.78272 0 25.677824-19.376128 42.79296-43.599872 42.79296z" />
                </svg>
                <div className="contact-divider"></div>
                <p className="contact-label">微信号</p>
                <p className="contact-value selectable-text">{contact.wechat}</p>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M926.47619 355.644952V780.190476a73.142857 73.142857 0 0 1-73.142857 73.142857H170.666667a73.142857 73.142857 0 0 1-73.142857-73.142857V355.644952l304.103619 257.828572a170.666667 170.666667 0 0 0 220.745142 0L926.47619 355.644952zM853.333333 170.666667a74.044952 74.044952 0 0 1 26.087619 4.778666 72.704 72.704 0 0 1 30.622477 22.186667 73.508571 73.508571 0 0 1 10.678857 17.67619c3.169524 7.509333 5.12 15.652571 5.607619 24.210286L926.47619 243.809524v24.380952L559.469714 581.241905a73.142857 73.142857 0 0 1-91.306666 2.901333l-3.632762-2.925714L97.52381 268.190476v-24.380952a72.899048 72.899048 0 0 1 40.155428-65.292191A72.97219 72.97219 0 0 1 170.666667 170.666667h682.666666z" />
                </svg>
                <div className="contact-divider"></div>
                <p className="contact-label">邮箱</p>
                <p className="contact-value selectable-text">{contact.email}</p>
              </div>
            </div>
          </div>

          <section className="support-section friend-links-section" aria-labelledby="friend-links-title">
            <h2 id="friend-links-title" className="weight-bold">友情链接</h2>

            <div className="friend-links-grid">
              <a
                href="https://www.oldgame.cz/zh/"
                className="friend-link-card friend-link-oldgame"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="访问 oldgame.cz 老游戏在线玩与下载（在新窗口打开）"
              >
                <div className="friend-link-logo">
                  <img
                    src={oldgameButton}
                    width="88"
                    height="31"
                    alt="oldgame.cz - 老游戏在线玩 / 下载"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="friend-link-copy">
                  <h3>oldgame.cz</h3>
                </div>
              </a>

              <a
                href="https://www.compumuseum.com/index.html"
                className="friend-link-card friend-link-compumuseum"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="访问网页里的电脑博物馆（在新窗口打开）"
              >
                <div className="friend-link-copy">
                  <h3>网页里的电脑博物馆</h3>
                </div>
              </a>

              <a
                href="https://pkugarc.com/"
                className="friend-link-card friend-link-pkugarc"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="访问游戏与艺术创研中心（在新窗口打开）"
              >
                <div className="friend-link-logo">
                  <img
                    src={pkugarcLogo}
                    alt="游戏与艺术创研中心"
                    className="friend-logo-pkugarc"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="friend-link-copy">
                  <h3>游戏与艺术创研中心</h3>
                </div>
              </a>

              <a
                href="https://www.xfkenzify.com:3002/"
                className="friend-link-card friend-link-fengcheng"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="访问枫城在线平台（在新窗口打开）"
              >
                <div className="friend-link-logo">
                  <img
                    src={fengchengLogo}
                    alt="枫城在线平台"
                    className="friend-logo-fengcheng"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="friend-link-copy">
                  <h3>枫城在线平台</h3>
                </div>
              </a>

              <a
                href="https://www.jlgames.cn/"
                className="friend-link-card friend-link-jlgames"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="访问瑾龙游戏（在新窗口打开）"
              >
                <div className="friend-link-logo">
                  <img
                    src={jlgamesLogo}
                    width="136"
                    height="40"
                    alt="瑾龙游戏"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="friend-link-copy">
                  <h3>瑾龙游戏</h3>
                </div>
              </a>
            </div>
          </section>

          <div className="support-section support-credits-section">
            <h2 className="weight-bold">致谢</h2>
            <p className="credits-subtitle">以下开源项目支持本站的运行</p>
            <div className="credits-grid">
              {credits.map((credit) => (
                <div key={credit.id} className="credit-item">
                  {credit.name && (
                    <h3 className="credit-name">{credit.name}</h3>
                  )}
                  {credit.logo && (
                    <div className="credit-logo-container">
                      <img 
                        src={`${API_BASE_URL}${credit.logo}`} 
                        alt={credit.name || 'Project Logo'}
                        className="credit-logo"
                      />
                    </div>
                  )}
                  <div className="credit-links">
                    {credit.github && (
                      <a 
                        href={credit.github} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="credit-link"
                      >
                        GitHub
                      </a>
                    )}
                    {credit.website && (
                      <a 
                        href={credit.website.startsWith('http') ? credit.website : `https://${credit.website}`}
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="credit-link"
                      >
                        官网
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="support-section">
            <h2 className="weight-bold">使用条款</h2>
            <p>请阅读我们的使用条款和隐私政策</p>
            <Link to="/about/terms" className="support-link">
              查看使用条款
            </Link>
          </div>
        </div>

        {/* QR Code Modal */}
        {showQRCode && (
          <div className="qr-code-modal-overlay" onClick={toggleQRCode}>
            <div className="qr-code-modal-content" onClick={e => e.stopPropagation()}>
              <button className="qr-code-close-button" onClick={toggleQRCode}>×</button>
              <h3 className="qr-code-title">微信赞赏码</h3>
              <div className="qr-code-image-container">
                <img src={qrCodeImage} alt="微信赞赏码" className="qr-code-image" />
              </div>
              <p className="qr-code-description">感谢您对怀旧游戏博物馆的支持！</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default About; 
